<template>
    <page>
        <module :title="id ? '编辑秒杀活动' : '新建秒杀活动'">
            <c-form ref="form" unit-width="500">
				<c-title>基础信息</c-title>
				<c-form-item label="活动名称" required>
					<c-input name="activity_name" placeholder="请输入活动名称" maxlength="20"></c-input>
					<c-input name="activity_id" type="hidden" v-model="activity_id" ></c-input>
				</c-form-item>
				<c-form-item label="活动时间" required>
					<c-datetime start-name="begin_date" end-name="end_date"range></c-datetime>
				</c-form-item>
				<c-form-item label="活动预告" tip="活动预告期间，商品详情页价格上方将会展示活动标题，开始时间和折扣力度。" required>
					<c-radio-group name="activity_notice" v-model="activityNotice" :options="activityNoticeOptions" ></c-radio-group>
				</c-form-item>
				<c-form-item label="提前预告时间" v-if="activityNotice == 1" required>
					<c-input type="number" decimal="1" :range="[1,240]" v-model="activityNoticeTime" name="activity_notice_time" unit="小时" style="width:120px"></c-input>
				</c-form-item>
				<c-form-item label="下单未支付时" tip="按照该配置订单未支付将自动取消" required>
					<c-radio-group name="auto_cancel" v-model="autoCancel" :options="cancelType" ></c-radio-group>
				</c-form-item>
				<c-form-item label="自动取消时长" v-if="autoCancel == 1" required>
					<c-input type="number" decimal="1" :range="[1,180]" v-model="cancelTime" name="cancel_time" unit="分钟" style="width:120px"></c-input>
				</c-form-item>
				<c-form-item label="活动标签">
					<c-input name="tags"  maxlength="4" placeholder="活动标签名称" ></c-input>
				</c-form-item>
				
				<c-title>活动商品</c-title>
				<c-form-item width="1100">
					<c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>

					<c-table ref="productList" :data="productList" height="auto" :paging="false" border>
						<c-table-column
								type="selector"
						></c-table-column>

					  <c-table-column
						  label="商品信息"
						  name="product_name"
						  width="250"
					  >
						<template v-slot="{data}">
							<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
							<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
						</template>
					  </c-table-column>

					  <c-table-column
								label="价格"
								name="product_price"
								width="130"
						>
							<template v-slot="{data}">￥{{data.product_price}}</template>
					  </c-table-column>

					  <c-table-column
								label="活动库存（单SKU）"
								name="activity_stock_count"
								width="130"
						>
						<template v-slot="{data}">
						  <c-input  v-model="data.activity_stock_count" width="80" type="number" :range="[1, 9999]"></c-input>
						</template>
					  </c-table-column>

					  <c-table-column
						  label="折扣"
						  width="100"
					  >
						<template v-slot="{data}">
						  <c-input :disabled="setConfigType == 2" decimal="1" :range="[0.1,10]" v-model="data.activity_discount" width="70" type="number" style="margin: 0 5px;" unit="折"></c-input>
						</template>
					  </c-table-column>

					  <c-table-column
						  label="促销价"
						  name="promotion_price"
						  width="140"
					  >
						<template v-slot="{data}">
						  <span v-if="data.activity_discount" >
								  ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
								  <span v-if="data.product_price_max">
									  - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
								  </span>
								</span>
						</template>
					  </c-table-column>

					  <c-table-column
								type="button"
								fixed="right"
								label="操作"
								width="80"
						>
							<template v-slot="row">
								<c-table-button  @click="deleteProduct(row.data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
            </c-form>

            <template slot="button">
				<c-button v-show="editFlag && auth('b_activity_secondkill_edit')" color="main" size="form" @click="submit()">确定提交</c-button>
            </template>
        </module>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
    import productSelector from '@/components/service/product_selector.vue'
    export default {
        name: 'activity_presell_edit',

        components: {
            productInfo,productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                setConfigType:1,
                activityNoticeTime: 0,
                activityNotice: 0,
                activityNoticeOptions: [{
                  name: '立即预告',
                  value: 0
                },{
                  name: '不预告',
                  value: -1
                },{
                  name: '提前预告',
                  value: 1
                }],
                activity_id: '',
                productList: [],
                editFlag: true,
				autoCancel: 1,
				cancelTime: 1,
				cancelType: [{
					name: '按指定时长自动取消',
					value: 1
				}, {
					name: '按系统配置自动取消',
					value: 0
				}]
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            },

            commodityRange(val) {
                if (val == 2) {
                    this.$refs.productList.resize();
                }
            }
        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activitySecondkill/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        if(data.start_state == 1){
                            this.editFlag = false;
                        }
                        this.activityNoticeTime = data.activity_notice_time;
                        this.productList = data.product_list;
                    }
                });
            },
            productSelectHandle(list) {
                list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
                });
                this.productList = this.productList.concat(list);
            },
			deleteProduct(rowData){
				const index = this.productList.indexOf(rowData);
				this.productList.splice(index, 1);
			},
            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/activitySecondkill/edit' : '/activitySecondkill/add',
                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
                        end_date: '请选择活动时间',
                        activity_notice: '请选择通知类型',
                        activity_notice_config: [{
                          type: 'function',
                          fun: (val,data) => {
                            //指定商品且设置折扣时判断
                            if(this.activityNotice == 1 && (!data.activity_notice_time || data.activity_notice_time<=0)){
                              return false;
                            }else return true;
                          },
                          message: '请填写提前预告时间'
                        }],
                        auto_cancel_config: [{
                          type: 'function',
                          fun: (val,data) => {
                            //自动取消时长时判断
                            if(this.autoCancel == 1 && (!data.cancel_time || data.cancel_time<=0)){
                              return false;
                            }else return true;
                          },
                          message: '请填写自动取消时长'
                        }],
						product_list: [{
						    type: 'function',
						    fun: () => {
						        return this.productList.length;
						    },
						    message: '请选择活动商品'
						}],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                              //必须填写活动库存
                              return !this.productList.find(item => {
                                return !item.activity_stock_count;
                              });
                            },
                            message: '请设置活动商品库存'
                        }],
                        discount_config: [{
                          type: 'function',
                          fun: () => {
                            //指定商品且设置折扣时判断
                              return !this.productList.find(item => {
                                return !item.activity_discount;
                              });
                          },
                          message: '请设置活动商品折扣'
                        }],
                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);

                        data.product_list = Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                activity_stock_count: item.activity_stock_count,
                                activity_discount: item.activity_discount
                            }
                        });
                        return data;
                    },

                    success: (data,obj) => {
                        if(obj != null && obj.length !=0){
                            var res = "【";
                            obj.forEach(item=>{
                                res+=item+","
                            })
                            res = res.substring(0,res.length-1);
                            res+="】"

                            this.$message({
								type:'success',
                                message: '保存成功,存在以下商品和其他活动时间冲突未能添加成功'+res.toString(),
                            });
                        }else{
                            this.$message({
								type:'success',
                                message: "保存成功",
                            });
                        }

                        this.navigateTo('/activity_secondkill');
                    }
                })
            }
        }
    }
</script>